function loadLocaleMessages() {
	const locales = {
		zh: {},
		en: {},
		th: {}
	}

	const files = import.meta.glob('./{zh,en,th}/*.(json|js)', {
		eager: true
	})

	for (const path in files) {
		const match = path.match(/\.\/(zh|en|th)\/([^/]+)\.(json|js)$/)
		if (match) {
			const lang = match[1]
			const namespace = match[2]
			const content = files[path].default || files[path]

			if (namespace === 'index') {
				Object.assign(locales[lang], content)
			} else {
				locales[lang][namespace] = content
			}
		}
	}
	return locales
}

export default loadLocaleMessages